/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.listBlobs'

export { $nsid }

/** List blob CIDs for an account, since some repo revision. Does not require auth; implemented by PDS. */
const main = l.query(
  $nsid,
  l.params({
    did: l.string({ format: 'did' }),
    since: l.optional(l.string({ format: 'tid' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 1000 }), 500),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    cids: l.array(l.string({ format: 'cid' })),
  }),
  ['RepoNotFound', 'RepoTakendown', 'RepoSuspended', 'RepoDeactivated'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
